export default __webpack_public_path__ + "static/media/food.a3e69899.jpg";